import {
  DateFormat,
  formatDate,
  formatName,
  getTimeDifference,
  ProfileImage,
  Rating,
  RatingSize,
  TimeUnit,
} from '@leland-dev/leland-ui-library';
import React from 'react';

import type { ReviewCardReviewFragment } from './__generated-gql-types__/ReviewCard.generated';

interface ReviewCardProps {
  review: ReviewCardReviewFragment;
  className?: string;
}
const ReviewCard: React.FC<ReviewCardProps> = ({ review, className }) => {
  const isWithinTwoYears =
    getTimeDifference(review.reviewedAt, Date.now(), TimeUnit.YEAR) < 2;

  return (
    <div className={className}>
      <div className="flex h-36 items-start rounded-lg border border-leland-gray-stroke p-5">
        <ProfileImage
          className="mr-4 hidden size-8 shrink-0 md:flex"
          pictureLink={review.applicant?.user.pictureLink}
          firstName={review.applicant?.user.firstName ?? ''}
          lastName={review.applicant?.user.lastName ?? ''}
          anonymous={review.anonymous || review.guestReviewer !== null}
        />
        <div className="flex size-full flex-col">
          <div className="mb-2 flex flex-row items-center">
            <p className="mr-2 truncate text-sm font-medium text-leland-gray-dark">
              Review by{' '}
              {review.anonymous
                ? 'Anonymous'
                : review.guestReviewer !== null
                  ? review.guestReviewer
                  : formatName({
                      firstName: review.applicant?.user.firstName ?? '',
                      lastName: review.applicant?.user.lastName ?? '',
                      shouldTruncateLastName: true,
                    })}
            </p>
            <div className="mr-2">
              <Rating
                totalStars={5}
                rate={review.rate}
                overallRate={review.overallRate}
                showRate
                size={RatingSize.SMALL}
              />
            </div>
            {isWithinTwoYears ? (
              <p className="hidden text-sm font-normal text-leland-gray-extra-light md:block">
                {formatDate(review.reviewedAt, DateFormat.LONG_MONTH_YEAR)}
              </p>
            ) : null}
          </div>
          {review.comment ? (
            <p className="line-clamp-3 text-base font-normal text-leland-gray-light">
              {review.comment}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
